import { FormControl, FormHelperText, InputLabel, MenuItem, Select, Stack } from '@mui/material'
import { getIn, useFormikContext } from 'formik';
import React from 'react'

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function FormSelectField({ name, emptyCheck,sx,children,label,onSelect, ...otherProps }) {

  const { values, touched, errors, setFieldValue, handleBlur, dirty, handleChange } = useFormikContext();

  return (
    <Stack sx={{ mb: '22px', ...sx }}>
      <FormControl sx={{ minWidth: 120 }}>
        <InputLabel id="demo-simple-select-helper-label">{label}</InputLabel>
        <Select
          labelId="demo-simple-select-helper-label"
          id="demo-simple-select-helper"
          value={getIn(values, name)}
          label={label}
          MenuProps={MenuProps}
          onChange={(event) => {
            const {multiple} = otherProps;
            if(multiple) {
              const value = event.target.value;
              if(onSelect) {
                onSelect(value);
              }
              setFieldValue(name, typeof value === 'string' ? value.split(',') : value)
            } else {
              if(onSelect) {
                onSelect(event.target.value);
              }
              setFieldValue(name, event.target.value);
            }
            
          }}
          error={Boolean(getIn(values, name) || emptyCheck) && getIn(touched, name) && Boolean(getIn(errors, name))}
          {...otherProps}
        >
          {children}
        </Select>
      </FormControl>
    </Stack>
  )
}
